import { useState } from "react";
import { Link } from "react-router-dom";
import { BsPlayCircle } from "react-icons/bs";
import { FaHeart } from "react-icons/fa";
import ReactionBar from "../ui/ReactionBar";
import useMediaActions from "../../hooks/useMediaActions";
import { useAuth } from "../../features/auth/AuthContext";

const EpisodeCard = ({ episode }) => {
  const { isAuthenticated } = useAuth();
  const [expanded, setExpanded] = useState(false);
  // Real state, rather than mutating the prop and forcing a re-render
  // through an unrelated piece of state as the original did.
  const actions = useMediaActions("episode", episode.id, episode.user_action);

  return (
    <div className="relative">
      <Link to={`/PlayEpisode/${episode.id}`} className="block cursor-pointer">
        <div className="relative">
          <img
            src={episode.cover}
            alt={episode.name}
            className="w-full rounded sm:h-[5rem] md:h-[7rem] lg:h-[11rem]"
            loading="lazy"
          />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <BsPlayCircle size={50} className="text-white" />
          </div>
        </div>
        <h3 className="mt-2 text-sm font-semibold leading-5">{episode.name}</h3>
      </Link>

      <div className="mt-2 flex items-center justify-between text-gray-600">
        <div className="flex items-center text-lg">
          <FaHeart />
          <span className="mr-1">{episode.like_percentage}%</span>
        </div>
        {isAuthenticated && (
          <ReactionBar
            actions={actions}
            showBookmark={false}
            size="text-2xl"
            className="gap-4"
          />
        )}
      </div>

      <div>
        <p
          className={`mt-2 overflow-hidden text-[#8a8a8a] transition-[max-height] duration-300 ${
            expanded ? "max-h-96" : "max-h-12"
          }`}
        >
          {episode.description}
        </p>
        <button
          type="button"
          onClick={() => setExpanded((value) => !value)}
          className="mt-2 text-blue-500 focus:outline-none"
        >
          {expanded ? "نمایش کمتر" : "ادامه..."}
        </button>
      </div>
    </div>
  );
};

const EpisodeList = ({ episodes = [] }) => {
  if (episodes.length === 0) return null;

  return (
    <div className="sm:mx-[20px] md:mx-[30px] lg:mx-[40px] xl:mx-[70px]">
      <h3 className="mx-4 mb-5 mt-8 text-2xl">قسمت ها</h3>
      <div className="grid grid-cols-2 gap-6 px-6 sm:grid-cols-3 md:grid-cols-4">
        {episodes.map((episode) => (
          <EpisodeCard key={episode.id} episode={episode} />
        ))}
      </div>
    </div>
  );
};

export default EpisodeList;
